import React from 'react'
import { colors } from 'src/theme'
import { Lexicons } from 'src/rest/types/Lexicon'
import { useTranslation } from 'react-i18next'

import LexiconTooltip from '../LexiconTooltip'

export type TooltipsProps = {
  lexicons: Lexicons
}

const Tooltips: React.FC<TooltipsProps> = ({ lexicons }) => {
  const { t } = useTranslation()
  return lexicons.map((lexique) => (
    <LexiconTooltip
      key={lexique.id}
      content={t('lexicons.tooltip.content')}
      color={colors.blueLight}
      anchorSelect={`[data-lexicon='${lexique.word.toLocaleLowerCase()}']`}
    />
  ))
}

export default Tooltips
